import { QueryClient } from '@tanstack/react-query';

/**
 * Shared TanStack Query client for live per-view reads (calendar/availability).
 * Short staleTime keeps polling cheap while still refetching on focus/reconnect
 * so a stale calendar view self-heals without an explicit user action.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      retry: 1,
    },
  },
});
